import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const sellViaExAgentRebateSerializeMap: SerializeMap<SellViaExAgentRebate> =
  {
    id: "id",
    billingSettingsId: "billing_settings_id",
    deploymentId: "deployment_id",
    propertyId: "property_id",
    saleSubTypeId: "sale_sub_type_id",
    speciesId: "species_id",
    saleType: "sale_type",
    sellViaExAgentRebateRate: "sell_via_ex_agent_rebate_rate",
  };

export const serializeSellViaExAgentRebate = buildSerializer(
  sellViaExAgentRebateSerializeMap,
  "sell via ex agent rebate",
);

export const deserializeSellViaExAgentRebate = buildDeserializer(
  sellViaExAgentRebateSerializeMap,
  "sell via ex agent rebate",
);
